export default {"src":"/_next/static/media/bed_24.6d82727a.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};